import { Link } from "react-router-dom";
import { COMPANY, NAV, LEGAL } from "@/data/site";
import { SERVICES } from "@/data/services";
import { Logo } from "@/components/Logo";

const Col = ({ title, children }) => (
  <div>
    <h2 className="eyebrow mb-5 text-lime">{title}</h2>
    <ul className="space-y-3 text-[0.95rem] text-white/80">{children}</ul>
  </div>
);

const FLink = ({ to, children, testid }) => (
  <li>
    <Link to={to} data-testid={testid} className="transition-colors duration-300 hover:text-lime">
      {children}
    </Link>
  </li>
);

export const Footer = () => (
  <footer className="on-dark relative overflow-hidden bg-midnight text-white" data-testid="site-footer">
    <div className="shell grid gap-14 pb-14 pt-20 md:grid-cols-2 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Logo variant="white" />
        <p className="mt-6 max-w-sm text-[0.95rem] leading-relaxed text-white/75">{COMPANY.description}</p>
        <p className="mt-4 text-xs text-white/60">SIC {COMPANY.sic}</p>
      </div>
      <div className="lg:col-span-2">
        <Col title="Explore">
          {NAV.map((n) => <FLink key={n.to} to={n.to} testid={`footer-nav-${n.testid}`}>{n.label}</FLink>)}
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Services">
          {SERVICES.map((s) => <FLink key={s.slug} to={`/services#${s.slug}`} testid={`footer-service-${s.slug}`}>{s.title}</FLink>)}
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Contact">
          <li><a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="break-all hover:text-lime">{COMPANY.email}</a></li>
          <li><a href={COMPANY.phoneHref} data-testid="footer-phone-link" className="hover:text-lime">{COMPANY.phone}</a></li>
          <li>
            <address className="not-italic leading-relaxed">
              {COMPANY.addressLines.map((l) => <span key={l} className="block">{l}</span>)}
            </address>
          </li>
        </Col>
      </div>
    </div>
    <div aria-hidden="true" className="shell select-none">
      <p className="text-outline font-display text-[24vw] font-extrabold leading-[0.78] tracking-[-0.08em] text-white/15 lg:text-[19rem]">PRPO</p>
    </div>
    <div className="border-t border-white/15">
      <div className="shell flex flex-col gap-4 py-6 text-sm text-white/70 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} PRPO LTD. All rights reserved.</p>
        <ul className="flex gap-6">
          {LEGAL.map((l) => <FLink key={l.to} to={l.to} testid={`footer-legal-${l.testid}`}>{l.label}</FLink>)}
        </ul>
      </div>
    </div>
  </footer>
);
